module.exports = __webpack_public_path__ + "dash_20_app_assets/img/OpenAnswer.55b9a8f4.png";